<template>
  <div class="goodsListIsNull">
    <!-- 没有搜索到您想要的商品，您可以尝试通过图片搜索。或者直接通过WhatsApp或者邮件联系我们。我们会帮您寻找合适的供应商。 -->
    <div class="message" :key="'no-data-msg-' + $store.state.fanyi">
      {{ nodataFont }}
    </div>
    <div class="whiteBg fontModel pabo50">
      <div class="expertAgent pageMoudle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          style="enable-background: new 0 0 24 24"
          xml:space="preserve"
        >
          <path
            class="st0"
            d="M11.4,1C6.6,1.3,3,5.5,3,10.3V17c0,1.7,1.3,3,3,3h1c1.1,0,2-0.9,2-2v-4c0-1.1-0.9-2-2-2H5v-1.7 C5,6.4,8,3.1,11.8,3c4-0.1,7.2,3.1,7.2,7v2h-2c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2h2v1h-6c-0.6,0-1,0.5-1,1s0.4,1,1,1h5 c1.7,0,3-1.3,3-3V10C21,4.8,16.6,0.7,11.4,1z"
          ></path>
        </svg>

        <div class="expertAgentCon" :key="'no-data-lang-' + $store.state.fanyi">
          <!-- 找不到你想要的吗？ -->
          <div>{{ $fanyi("找不到你想要的吗？") }}</div>
          <p>
            {{ $fanyi("我们的搜索引擎会自动翻译成中文以进行搜索。") }}<br />
            {{ $fanyi("你输入的关键词翻译可能不正确。") }}<br />
            {{ $fanyi("如果你需要帮助寻找所需产品，请直接联系我们。") }}
          </p>
          <!-- 与代理聊天 -->
          <button @click="openChat">{{ $fanyi("与代理聊天") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {
    // 顶部无结果提示：接口文案优先，否则默认 i18n（中文名：无结果顶部文案）
    nodataFont() {
      const _lang = this.$store.state.fanyi;
      void _lang;
      if (this.$parent.nodataFontOverride) {
        return this.$parent.nodataFontOverride;
      }
      return this.$fanyi(
        "没有搜索到您想要的商品，您可以尝试通过图片搜索。或者直接通过WhatsApp或者邮件联系我们。我们会帮您寻找合适的供应商。"
      );
    },
  },

  created() {},

  methods: {
    // 打开客服/WhatsApp 联系

    openChat() {
      this.$fun.clickJs();
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.st0 {
  fill: #99aef0;
}

.goodsListIsNull {
  width: 100%;

  min-width: 1400px;

  .message {
    width: 695px;

    margin: 110px auto 100px;

    text-align: center;

    font-size: 22px;

    font-weight: 400;

    color: #2f2f2f;

    line-height: 36px;
  }
}

.whiteBg {
  background-color: white;
}

.pabo50 {
  padding-bottom: 50px;
}

.fontModel {
  padding-top: 50px;

  @extend .dip;
}

.expertAgent {
  width: 1200px;

  height: 451.08px;

  margin: 0 auto;

  background-color: #f8f9fa;

  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;

  @extend .fdcolmun;

  justify-content: center;

  svg {
    width: 40px;

    height: 40px;

    display: block;

    margin: 0 auto;
  }

  .expertAgentCon {
    width: 680px;

    padding: 10px;

    margin: 0 auto;

    > * {
      text-align: center;
    }

    display: flex;

    flex-wrap: wrap;

    justify-content: center;

    > div:first-child {
      font-size: 21px;

      font-weight: 500;

      line-height: 1.5em;

      margin-bottom: 10px;
    }

    p {
      width: 660px;

      font-size: 16px;

      font-weight: 400;

      line-height: 1.8em;

      margin-bottom: 34px;
    }

    button {
      font-size: 16px;

      line-height: 20px;

      font-weight: 400;

      width: 337px;

      height: 60px;

      padding: 20px 80px;

      border-radius: 12px;

      border: none;

      background: #009246;

      color: #ffffff;

      transition: background-color 0.3s;

      cursor: pointer;

      &:hover {
        background-color: #2a6418;

        color: #ffffff;
      }
    }
  }
}
</style>
